<template>
	<div class="counter-order"
		 :class="{'swipe-delete': translateX > 0}"
		 v-swipe="swipeHandler" >
		<div class="counter-header">
			<div class="row-header">
				<div class="order-existence">{{ orderExistence }}</div>
				<div class="order-title">{{ orderTitle }}</div>
			</div>
			<div class="row-header mt-5">
				<div class="order-switches">
					<div v-if="counterStore.editOrder" class="order-switch order-switch-selected" @click="counterStore.finishEditOrder">
						<img :src="'https://img.qromo.io/img/icons/icon-x.svg'">
					</div>
					<div class="order-switch" v-if="counterSelectable" :class="{selected: selectedCounter}" @click="selectDirectSale">
						<img class="icon-dimension-20" :src="'https://img.qromo.io/img/icons/icon-direct-sale-primary'+(userStore.darkMode ? '-dark' : '')+'.svg'">
					</div>
					<div v-if="qrSelectable" class="order-switch" :class="{selected: selectedQr}" @click="selectQr">
						<img :src="'https://img.qromo.io/img/icons/icon-counter-table-primary'+(userStore.darkMode ? '-dark' : '')+'.svg'">
					</div>
					<div v-if="deliverySelectable" class="order-switch" :class="{selected: selectedDelivery}" @click="selectDelivery">
						<img :src="'https://img.qromo.io/img/icons/icon-counter-delivery-primary'+(userStore.darkMode ? '-dark' : '')+'.svg'">
					</div>
					<div v-if="takeawaySelectable" class="order-switch" :class="{selected: selectedTakeaway}" @click="selectTakeaway">
						<img :src="'https://img.qromo.io/img/icons/icon-takeaway-'+(userStore.currBusiness && userStore.currBusiness.type === 'other' ? 'other' : 'generic')+'-primary'+(userStore.darkMode ? '-dark' : '')+'.svg'">
					</div>
				</div>
				<div class="order-edit">
					<AppButtonIcon icon-name="icon-edit-white" prevent-change @click-icon="orderEditorActive = true" />
				</div>
			</div>
		</div>
		<div class="counter-body" ref="counter-body">
			<div class="items-container">
				<div class="items-summary-container">
					<OrderSummaryItem v-for="item in currItems" :key="item.identifier" :item="item" deletable @delete="quantity => deleteItem(item, quantity)" is-in-counter />
					<OrderSummaryItemFake :title="getString('fake_item')" v-for="item in counterStore.fakeItems" :key="item.identifier" :price="item.price" :quantity="item.quantity" deletable @changed-quantity="q => counterStore.changeQuantityCartFakeItem(item, q)" @changed-price="p => counterStore.changePriceCartFakeItem(item, p)" is-in-counter />
					<!-- Additional costs -->
					<OrderSummaryItem v-if="this.counterStore.tip > 0" :key="tipItem.identifier" :item="tipItem" :disable-click="true" is-in-counter/>
					<OrderSummaryItem v-if="currItems.length === 0 && counterStore.fakeItems.length === 0 && !(counterStore.coverNum > 0) && counterStore.deliveryCosts <= 0 && counterStore.takeawayCosts <= 0" :item="null" is-in-counter />
					<OrderSummaryItemFake :title="coverChargeName" v-if="counterStore.coverNum > 0" :price="counterStore.coverCharge" :quantity="counterStore.coverNum" deletable @changed-quantity="q => counterStore.coverNum = q" @changed-price="p => counterStore.coverCharge = p" image="https://img.qromo.io/img/icons/icon-coperto-plus-cost.svg" is-in-counter />
					<div class="button-costs-container" v-else-if="selectedQr">
						<AppButton class="button-costs" :text="getString('add_cover_charge')" small outline @click="addCoverCharge" />
					</div>
					<div class="button-costs-container" v-if="shortcutsCategories.button.length || shortcutsCategories.slider.length">
						<AppButton v-for="category in shortcutsCategories.button" class="button-costs" :text="getString('add_x', [category?.name])" small outline @click="toggleAdditionalCostsBottomSheet(category?.menu_category_id)" />
						<AdditionalShortcutsSelector v-for="category in shortcutsCategories.slider" :category-id="Number(category.menu_category_id)" @picked-item="pickedAdditionalCostItem" class="mb-12" />
					</div>
					<OrderSummaryItemFake :title="getString('delivery_costs')" v-if="counterStore.deliveryCosts > 0" :price="counterStore.deliveryCosts" :quantity="null" deletable @changed-quantity="counterStore.deliveryCosts = 0" @changed-price="p => counterStore.deliveryCosts = p" image="https://img.qromo.io/img/icons/icon-delivery-plus-cost.svg" is-in-counter />
					<div class="button-costs-container" v-else-if="counterStore.selectedMode === 'delivery'">
						<AppButton class="button-costs" :text="getString('add_delivery_costs')" small outline @click="addDeliveryCosts" />
					</div>
					<OrderSummaryItemFake :title="getString('takeaway_costs')" v-if="counterStore.takeawayCosts > 0" :price="counterStore.takeawayCosts" :quantity="null" deletable @changed-quantity="counterStore.takeawayCosts = 0" @changed-price="p => counterStore.takeawayCosts = p" image="https://img.qromo.io/img/icons/icon-takeaway-plus-cost.svg" is-in-counter />
					<div class="button-costs-container" v-else-if="counterStore.selectedMode === 'takeaway'">
						<AppButton class="button-costs" :text="getString('add_takeaway_costs')" small outline @click="addTakeawayCosts" />
					</div>
				</div>
				<div class="notes-container" v-if="counterStore.orderNotes">
					<div class="notes-title">{{ getString('order_notes') }}</div>
					<div class="notes-body">{{ counterStore.orderNotes }}</div>
				</div>
			</div>
		</div>
		<div class="courses-selector-container" v-if="counterStore.withCourses">
			<div class="courses-selector">
				<div class="course-selector" v-for="i in counterStore.maxCourse" :key="i" :class="{selected: counterStore.selectedCourse === i, current: counterStore.runningCourse === i, done: counterStore.runningCourse && i < counterStore.runningCourse}" @click="changeCourse(i)">{{ i }}</div>
				<div class="course-add" @click="increaseMaxCourse">+</div>
			</div>
		</div>
		<div class="counter-bottom">
			<div class="total">
				<div class="total-title">{{ getString('total') }}</div>
				<div class="total-value"><span class="total-value-discount" v-if="counterStore.additionalCosts !== 0">{{ currencyStore.readableCurrencyValue(counterStore.cartTotal) }}</span>{{ currencyStore.readableCurrencyValue(counterStore.grandTotal) }}</div>
			</div>
			<div class="bottom-half">
				<div v-if="showSubtotal" class="custom-button secondary-action outline" :class="{disabled: counterStore.cartItemsCount === 0 || !userStore.checkOrderDiscountAllowed}" @click="subtotalActive = true">
					<span class="button-text">{{ getString('subtotal') }}</span>
				</div>
				<div v-if="showSecondaryAction" class="custom-button secondary-action outline" :class="{disabled: secondaryActionDisabled, loading: loadingCta}" @click="performSecondaryAction">
					<AppLoader v-if="loadingCta" :size="14" />
					<span class="button-text" v-else>{{ secondaryActionTitle }}</span>
				</div>
			</div>
			<div class="primary-action-container">
				<div v-if="showShortcutButton" class="custom-button mini-action outline" :class="{disabled: shortcutDisabled, loading: loadingCta}" @click="performShortcut">
					<AppLoader v-if="loadingCta" :size="14" />
					<img v-else-if="shortcutIcon" class="button-icon" :src="'https://img.qromo.io/img/icons/'+shortcutIcon+(userStore.darkMode ? '-dark' : '')+'.svg'" alt="shortcut icon" />
				</div>
				<div class="custom-button primary-action" :class="{disabled: primaryActionDisabled, loading: loadingCta}" @click="performPrimaryAction">
					<AppLoader v-if="loadingCta" :size="14" color="#ffffff" />
					<span class="button-text" v-else>{{ primaryActionTitle }}</span>
				</div>
			</div>
		</div>
		<div class="sheets-container" v-if="ordersStore.showMobileOrderSummary || counterStore.paymentActive || windowWidth > 750">
			<BottomNumberEditor :active="subtotalActive" :title="getString('subtotal_x', [currencyStore.currCurrency.symbol])" :start-price-name="getString('subtotal')" :starting-number="counterStore.grandTotal-counterStore.subtotalCosts" @toggling-popup="togglingSubtotal" @confirm-number="confirmSubtotal" />
			<BottomItemEditor />
			<BottomShortcutsSelector :category-id="shortcutsCategoryId" @picked-item="pickedAdditionalCostItem" @closing-popup="shortcutsCategoryId = null" />
			<BottomOrderEditor :active="orderEditorActive" @toggling-popup="togglingOrderEditor" />
			<BottomPayment is-counter ref="bottom-payment" :items-split="itemsSplit" :active="counterStore.paymentActive" @toggling-popup="togglingPayment" @payment-done="clickCta" :total="counterStore.grandTotal" :default-dutch-people="defaultDutchPeople" />
			<NotInPlaceForm :type="notInPlaceType" :active="notInPlaceActive" @toggling-popup="togglingNotInPlace" />
		</div>
	</div>
</template>

<script>
import AppButtonIcon from "@/shared/components/AppButtonIcon.vue";
import AppButton from "@/shared/components/AppButton.vue";
import AppLoader from "@/shared/components/AppLoader.vue";
import {useCurrencyStore, useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useMenuStore, useOrdersStore, useUserStore, useAblyStore, useFunnelStore, useRoomsStore, useCustomersStore, useEpsonStore} from "@/console-new/stores";
import OrderSummaryItem from "@/console-new/components/ops/orders/OrderSummaryItem.vue";
import {useCounterStore} from "@/console-new/stores/counter.store";
import BottomNumberEditor from "@/console-new/components/ops/counter/BottomNumberEditor.vue";
import BottomShortcutsSelector from "@/console-new/components/ops/counter/BottomShortcutsSelector.vue";
import AdditionalShortcutsSelector from "@/console-new/components/ops/counter/AdditionalShortcutsSelector.vue";
import BottomItemEditor from "@/console-new/components/ops/counter/BottomItemEditor.vue";
import BottomPayment from "@/console-new/components/ops/counter/BottomPayment.vue";
import NotInPlaceForm from "@/console-new/components/ops/counter/NotInPlaceForm.vue";
import BottomOrderEditor from "@/console-new/components/ops/counter/BottomOrderEditor.vue";
import OrderSummaryItemFake from "@/console-new/components/ops/orders/OrderSummaryItemFake.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import API from "@/shared/helpers/API";

export default {
	components: {
		BottomPayment, AdditionalShortcutsSelector, BottomShortcutsSelector, BottomNumberEditor, OrderSummaryItem, AppButton, AppButtonIcon, AppLoader, BottomItemEditor, NotInPlaceForm, BottomOrderEditor, OrderSummaryItemFake},
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		let menuStore = useMenuStore();
		let ordersStore = useOrdersStore();
		let notificationStore = useNotificationStore();
		let customersStore = useCustomersStore();
		const counterStore = useCounterStore();
		const ablyStore = useAblyStore();
		const roomsStore = useRoomsStore();
		const funnelStore = useFunnelStore();
		const currencyStore = useCurrencyStore();
		return {getString: languageStore.getString, customersStore, languageStore, currencyStore, funnelStore, userStore, menuStore, notificationStore, counterStore, roomsStore, ordersStore, ablyStore};
	},
	props: {
		activeMenuId: {
			type: Number,
			default: null
		},
	},
	mixins: [WindowWidth],
	data() {
		return {
			subtotalActive: false,
			orderEditorActive: false,
			notInPlaceActive: false,
			tablesActive: false,
			loadingCta: false,
			notInPlaceType: 'delivery',
			translateX: 0,
			endingAnimation: false,
			shortcutsCategoryId: null,
			postTableSelectAction: null,
			paramsCustomerToken: null,
		}
	},
	name: "CounterOrder",
	computed: {
		shortcutsCategories() {
			let returningCategories = {
				button: [],
				slider: []
			};
			Object.values(this.menuStore?.categories || {}).forEach((category) => {
				if(category?.additional_costs_shortcuts && category?.menu_id === this.activeMenuId) {
					let categoryItems = Object.values(category.items || {}).filter(it => !it?.deleted_item);
					if(categoryItems?.length) {
						let manyItems = categoryItems.length > 3;
						let pushingCategory = {
							...category,
							items: categoryItems
						}
						returningCategories[manyItems ? 'button' : 'slider'].push(pushingCategory);
					}
				}
			});
			return returningCategories;
		},
		showSubtotal() {
			return !this.userStore.currBusiness || !this.userStore.currBusiness.counter_hide_subtotal;
		},
		showShortcutButton() {
			if(this.counterStore.editOrder) {
				return false;
			}
			return this.userStore.currBusiness && !!this.userStore.currBusiness.counter_shortcut;
		},
		showSecondaryAction() {
			if(this.userStore.currBusiness) {
				if(this.counterStore.editOrder) {
					return false;
				} else {
					return !this.userStore.currBusiness.counter_hide_secondary;
				}
			} else {
				return true;
			}
		},
		secondaryActionTitle() {
			if(this.userStore.currBusiness) {
				if(this.counterStore.editOrder) {
					return this.getString('payment');
				} else {
					return this.userStore.currBusiness.counter_primary === "prepare" ? this.getString('payment') : this.getString('prepare');
				}
			} else {
				return this.getString('payment');
			}
		},
		primaryActionTitle() {
			if(this.userStore.currBusiness) {
				if(this.counterStore.editOrder) {
					return this.getString('edit');
				} else {
					return this.userStore.currBusiness.counter_primary === "prepare" ? this.getString('prepare') : this.getString('payment');
				}
			} else {
				return this.getString('prepare');
			}
		},
		secondaryActionDisabled() {
			if(this.counterStore.editOrder) {
				return true;
			} else {
				if(this.userStore.currBusiness) {
					if(this.userStore.currBusiness.counter_primary === "prepare") {
						return this.counterStore.cartTotal === 0 || !this.userStore.checkAnyOrderPayAllowed;
					} else {
						return this.counterStore.cartItemsCount === 0;
					}
				} else {
					return true;
				}
			}
		},
		primaryActionDisabled() {
			if(this.userStore.currBusiness) {
				if(this.counterStore.editOrder) {
					return this.counterStore.cartItemsCount === 0;
				} else {
					if(this.userStore.currBusiness.counter_primary === "prepare") {
						return this.counterStore.cartItemsCount === 0;
					} else {
						return this.counterStore.cartTotal === 0 || !this.userStore.checkAnyOrderPayAllowed;
					}
				}
			} else {
				return true;
			}
		},
		shortcutIcon() {
			if(this.counterStore.editOrder) {
				return null;
			}
			if(this.userStore.currBusiness && this.userStore.currBusiness.counter_shortcut) {
				if(this.userStore.currBusiness.counter_shortcut === "cash") {
					return "icon-money-blue";
				} else if(this.userStore.currBusiness.counter_shortcut === "card") {
					return "icon-card-blue-new";
				} else if(this.userStore.currBusiness.counter_shortcut === "paylater") {
					return "icon-paylater-white-2";
				} else {
					return null;
				}
			} else {
				return null;
			}
		},
		shortcutDisabled() {
			if(this.counterStore.editOrder) {
				return true;
			} else {
				if(this.userStore.currBusiness) {

					if (this.counterStore.cartTotal === 0) {
						return true;
					}
					else {
						if(this.userStore.currBusiness.counter_shortcut === "cash") {
							return !this.userStore.checkOrderPayCashAllowed;
						} else if(this.userStore.currBusiness.counter_shortcut === "card") {
							return !this.userStore.checkOrderPayPosAllowed;
						} else if(this.userStore.currBusiness.counter_shortcut === "paylater") {
							return !this.userStore.checkOrderPayOtherAllowed;
						}
						else {
							return true;
						}
					}
				} else {
					return false;
				}
			}
		},
		itemsSplit() {
			let id = 0;
			let items = [];
			if(this.counterStore.coverNum > 0 && this.counterStore.coverCharge > 0) {
				items.push({
					id: id,
					order_item_id: "cover",
					name: this.coverChargeName,
					price: this.counterStore.coverCharge,
					quantity: this.counterStore.coverNum,
					redeemed: false,
				});
				id++;
			}
			this.counterStore.cartItems.forEach(item => {
				let priceFull = item.price + item.products.reduce((a, b) => a + (b.price*b.quantity), 0);
				if(priceFull > 0) {
					items.push({
						id: item.identifier,
						menu_item_id: item.menu_item_id,
						name: item.name,
						price: priceFull,
						quantity: item.quantity,
						redeemed: 0,
						products: item.products
					});
					id++;
				}
			});
			return items;
		},
		orderExistence() {
			if(this.counterStore.editOrder) {
				return this.getString('order_edit');
			} else {
				return this.getString('new_order');
			}
		},
		orderTitle() {
			if(this.counterStore.editOrder) {
				return this.counterStore.editOrder.orderNumberDayFormatted;
			} else {
				return this.counterStore.modeTitle;
			}
		},
		counterSelectable() {
			return this.counterStore.editOrder ? this.selectedCounter : true;
		},
		qrSelectable() {
			let show = false;

			if(this.counterStore.editOrder) {
				show = this.userStore.checkOrderEditAllowed ? this.selectedQr : false;
			}
			else if(this.userStore.checkOrderCreationAllowed) {
				show = this.userStore.currBusinessId && (this.userStore.currPlans.order_pay || this.userStore.currPlans.pay_bill);
			}

			return show;
		},
		deliverySelectable() {
			let show = false;

			if(this.counterStore.editOrder) {
				show = this.userStore.checkOrderEditAllowed ? this.selectedDelivery : false;
			}
			else if (this.userStore.checkOrderCreationAllowed) {
				show = this.userStore.currBusinessId && this.userStore.currPlans.delivery;
			}

			return show;
		},
		takeawaySelectable() {
			let show = false;

			if(this.counterStore.editOrder) {
				show = this.userStore.checkOrderEditAllowed ? this.selectedTakeaway : false;
			}
			else if (this.userStore.checkOrderCreationAllowed) {
				show = this.userStore.currBusinessId && this.userStore.currPlans.takeaway;
			}

			return show;
		},
		selectedCounter() {
			if(this.counterStore.editOrder) {
				return this.counterStore.editOrder.order_mode === "counter";
			} else {
				return this.counterStore.selectedMode === "counter";
			}
		},
		selectedQr() {
			if(this.counterStore.editOrder) {
				return this.counterStore.editOrder.order_mode === "qr";
			} else {
				return this.counterStore.selectedMode === "qr";
			}
		},
		selectedDelivery() {
			if(this.counterStore.editOrder) {
				return this.counterStore.editOrder.order_mode === "delivery";
			} else {
				return this.counterStore.selectedMode === "delivery";
			}
		},
		selectedTakeaway() {
			if(this.counterStore.editOrder) {
				return this.counterStore.editOrder.order_mode === "takeaway";
			} else {
				return this.counterStore.selectedMode === "takeaway";
			}
		},
		currItems() {
			if(this.counterStore.withCourses) {
				return this.counterStore.cartItems.filter(item => item.course === this.counterStore.selectedCourse);
			} else {
				return this.counterStore.cartItems;
			}
		},
		defaultDutchPeople() {
			return Math.max(this.counterStore.coverNum, 2);
		},
		coverChargeName() {
			if(this.counterStore.selectedTable?.room_id && this.roomsStore.roomsIds[this.counterStore.selectedTable.room_id]) {
				return this.roomsStore.roomsIds[this.counterStore.selectedTable.room_id]?.cover_charge_name || this.getString('cover_charge');
			}
			return this.getString('cover_charge');
		},
		tipItem() {
			return {
				identifier: 'tip',
				quantity: 1,
				price: this.counterStore.tip,
				menu_item_id: 'tip',
				menu_item: {
					name: this.languageStore.getString('pos_tips'),
					picture: "https://img.qromo.io/img/icons/icon-fake-product.svg"
				},
				products: [],
				note: '',
				course: '',
				redeemed: 1
			}
		}
	},
	methods: {
		performPrimaryAction() {
			if(this.loadingCta) return;
			if(this.counterStore.editOrder) {
				this.clickPrepare();
			} else {
				if(!["basic", "free"].includes(this.userStore.currSubscription) && this.userStore.currBusiness?.counter_mandatory_table && this.counterStore.selectedMode === 'counter') {
					this.counterStore.tablesActive = true;
					this.$nextTick(()=>{
						this.postTableSelectAction = this.performPrimaryAction;
					});
					return;
				}
				if(this.userStore.currBusiness && this.userStore.currBusiness.counter_primary === "prepare") {
					this.clickPrepare();
				} else {
					this.counterStore.paymentActive = true;
				}
			}
		},
		performSecondaryAction() {
			if(this.loadingCta) return;
			if(!this.counterStore.editOrder) {
				if(!["basic", "free"].includes(this.userStore.currSubscription) && this.userStore.currBusiness?.counter_mandatory_table && this.counterStore.selectedMode === 'counter') {
					this.counterStore.tablesActive = true;
					this.$nextTick(()=>{
						this.postTableSelectAction = this.performSecondaryAction;
					});
					return;
				}
				if(this.userStore.currBusiness && this.userStore.currBusiness.counter_primary === "prepare") {
					this.counterStore.paymentActive = true;
				} else {
					this.clickPrepare();
				}
			}
		},
		performShortcut() {
			if(this.loadingCta) return;
			if(!this.counterStore.editOrder) {
				if(this.userStore.currBusiness.counter_shortcut === "cash") {
					this.clickCta("cash");
				} else if(this.userStore.currBusiness.counter_shortcut === "card") {
					if(this.$refs && this.$refs["bottom-payment"]) {
						this.counterStore.paymentActive = true;
						this.$nextTick(() => {
							this.$refs["bottom-payment"].startPayment('pos-fast');
						});
					}
				}
			}
		},
		swipeHandler(trigger, isRight, translationX) {
			if(!this.endingAnimation && this.windowWidth <= 750) {
				this.translateX = translationX < 0 ? 0 : translationX;
			}
		},
		deleteItem(item, quantity) {
			if(quantity === -1) {
				this.counterStore.removeCartItem(item, item.quantity);
			} else {
				this.counterStore.removeCartItem(item, quantity);
			}
		},
		increaseMaxCourse() {
			this.counterStore.maxCourse++;
			this.counterStore.selectedCourse = this.counterStore.maxCourse;
			if(this.windowWidth <= 750) {
				this.ordersStore.deactivateMobileOrderSummary();
			}
		},
		changeCourse(i) {
			this.counterStore.selectedCourse = i;
			this.counterStore.removeUnusedCourses(i);
		},
		pickedAdditionalCostItem(item) {
			this.counterStore.addCartItem(item);
			this.shortcutsCategoryId = null;
		},
		addCoverCharge() {
			const roomTableId = this.counterStore?.selectedTable?.room_table_id;
			let foundRoom = roomTableId ? this.roomsStore.roomFromTableId(roomTableId) : null;
			this.counterStore.coverNum = 1;
			if(foundRoom && foundRoom?.cover_charge !== null) {
				this.counterStore.coverCharge = foundRoom.cover_charge;
			} else {
				this.counterStore.coverCharge = this.currencyStore?.currMinInteger || 100;
			}
		},
		toggleAdditionalCostsBottomSheet(categoryId) {
			this.shortcutsCategoryId = Number(categoryId);
		},
		addDeliveryCosts() {
			if(this.userStore.currBusiness.delivery_costs) {
				this.counterStore.deliveryCosts = this.userStore.currBusiness.delivery_costs;
			} else {
				this.counterStore.deliveryCosts = this.currencyStore?.currMinInteger || 100;
			}
		},
		addTakeawayCosts() {
			if(this.userStore.currBusiness.takeaway_costs) {
				this.counterStore.takeawayCosts = this.userStore.currBusiness.takeaway_costs;
			} else {
				this.counterStore.takeawayCosts = this.currencyStore?.currMinInteger || 100;
			}
		},
		togglingPayment(isOpen) {
			if(!isOpen) {
				this.counterStore.paymentActive = false;
			}
		},
		togglingOrderEditor(isOpen) {
			if(!isOpen) {
				this.orderEditorActive = false;
			}
		},
		togglingNotInPlace(isOpen) {
			if(!isOpen) {
				this.notInPlaceActive = false;
			}
		},
		togglingSubtotal(isOpen) {
			if(!isOpen) {
				this.subtotalActive = false;
			}
		},
		confirmSubtotal(number) {
			this.counterStore.subtotalCosts = number-this.counterStore.totalPreSubtotal;
			this.subtotalActive = false;
		},
		clickPrepare() {
			if(this.counterStore.editOrder) {
				const orderId = this.counterStore.editOrder.order_id;
				const roomTableId = this.counterStore.editOrder.room_table_id;
				const searchQuery = roomTableId ? "tid:"+roomTableId : "id:"+orderId;
				this.loadingCta = true;
				this.counterStore.performEditOrder((r) => {
					this.loadingCta = false;
					if(r) {
						this.ordersStore.search = searchQuery;
						this.ordersStore.showCompleted = false;
						this.ordersStore.filterCounter = true;
						this.ordersStore.filterDelivery = true;
						this.ordersStore.filterTakeaway = true;
						this.ordersStore.filterRooms = true;
						this.ordersStore.refreshOrders();
						this.counterStore.finishEditOrder();
						this.$router.push("/ops/orders");
					}
				});

			} else {
				if (this.userStore.isOverCashLimit) {
					let maxFreeCashAmount = this.currencyStore.currCurrency?.max_free_weekly_cash_amount || 300000;
					let formattedMaxCash = this.currencyStore.readableCurrencyValue(maxFreeCashAmount, true, true, true);
					this.notificationStore.showNotification("cash-limit-exceeded", [formattedMaxCash]);
					return;
				}
				this.clickCta();
			}
		},
		clickCta(paymentType = null, amountPaidPartial = null, partialType = null, orderCreatedId = null, itemsSplit = null, dutchPeople = null, discountOnTotal = null, discountPartial = null, appliedCoupons = null, printSingleItem = false, callback = null) {
			this.counterStore.paymentActive = false;
			if(paymentType) {
				this.counterStore.paymentMethod = paymentType;
			}
			if(discountPartial) {
				this.counterStore.subtotalCosts -= discountPartial;
			}
			if(!orderCreatedId) {
				this.loadingCta = true;
				let onlyTotalItem = this.$refs["bottom-payment"]?.onlyTotalItem || printSingleItem;
				this.counterStore.createOrder(amountPaidPartial, discountOnTotal, appliedCoupons, itemsSplit, dutchPeople, false, onlyTotalItem, (result, orderId) => {
					this.loadingCta = false;
					if(result !== "success") {
						if(result === "total_too_high") {
							callback && callback(false);
							this.notificationStore.showNotification("total-too-high");
						} else if(result === "cash_limit_exceeded") {
							callback && callback(false);
							let maxFreeCashAmount = this.currencyStore.currCurrency?.max_free_weekly_cash_amount || 300000;
							let formattedMaxCash = this.currencyStore.readableCurrencyValue(maxFreeCashAmount, true, true, true);
							this.notificationStore.showNotification("cash-limit-exceeded", [formattedMaxCash]);
						} else if(result === "total_too_low") {
							callback && callback(false);
							let formattedMinAmount = this.currencyStore.readableCurrencyValue(this.currencyStore.currCurrency.min_stripe_amount);
							this.notificationStore.showNotification("total-too-low", [formattedMinAmount]);
						} else if((result?.details === "no_credit_available") && result?.customer_id && result?.customer_type) {
							let referenceObj = this.customersStore[result.customer_type === 'person' ? 'peoplesIds' : 'companiesIds']
							let referenceArray = this.customersStore[result.customer_type === 'person' ? 'customersPeople' : 'customersCompanies']
							let normalizeFn = this.customersStore[result.customer_type === 'person' ? 'normalizeCustomerPerson' : 'normalizeCustomerCompany']
							if(referenceObj[result.customer_id]) {
								API.init().getCustomer(this.userStore.currBusinessId, result.customer_id, result.customer_type, r => {
									let fetchedCustomer = r && r.result === "OK" ? r.customer : null;
									fetchedCustomer = fetchedCustomer ? normalizeFn(fetchedCustomer) : null;
									if(fetchedCustomer) {
										let currentIndex = referenceArray.findIndex(c => c.customer_id === fetchedCustomer.customer_id);
										if(currentIndex !== -1) {
											referenceArray.splice(currentIndex, 1, fetchedCustomer);
										}
										let regCustomer = this.counterStore?.registryEditingCustomer;
										let selCustomer = this.counterStore?.selectedCustomer;
										if(regCustomer?.type === result.customer_type && regCustomer?.customer_id === fetchedCustomer.customer_id) {
											this.counterStore.registryEditingCustomer = {...fetchedCustomer, type: result.customer_type};
										}
										if(selCustomer?.type === result.customer_type && selCustomer?.customer_id === fetchedCustomer.customer_id) {
											this.counterStore.selectedCustomer = {...fetchedCustomer, type: result.customer_type};
										}
									}
									this.notificationStore.showNotification("error-credit-mismatch");
									callback && callback(false);
								});
							} else {
								this.notificationStore.showNotification("error-credit-mismatch");
								callback && callback(false);
							}

						} else {
							callback && callback(false);
							this.notificationStore.showNotification("generic-fail");
						}
					} else {
						callback && callback(true);
						this.ordersStore.deactivateMobileOrderSummary();
						if(amountPaidPartial && orderId) {
							this.ordersStore.search = "id:"+orderId;
							this.ordersStore.showCompleted = false;
							this.ordersStore.filterCounter = true;
							this.ordersStore.filterDelivery = true;
							this.ordersStore.filterTakeaway = true;
							this.ordersStore.filterRooms = true;
							this.ordersStore.refreshOrders();
							this.$router.push("/ops/orders");

							this.ordersStore.ctaIsDueForOrderId = orderId;
							this.ordersStore.ctaIsPaymentPartial = partialType;
							setTimeout(() => {
								this.ordersStore.ctaIsDueForOrderId = null;
								this.ordersStore.ctaIsPaymentPartial = null;
							}, 2200);
						}
					}
				});
			} else {
				callback && callback("success");
				this.counterStore.selectedCustomer = null;
				this.counterStore.updateMostSoldProducts(this.counterStore.cartItems);
				this.counterStore.clearCart();
				this.$nextTick(() => {
					this.ordersStore.deactivateMobileOrderSummary();
				});
				if(amountPaidPartial) {
					this.ordersStore.search = "id:"+orderCreatedId;
					this.ordersStore.showCompleted = false;
					this.ordersStore.filterCounter = true;
					this.ordersStore.filterDelivery = true;
					this.ordersStore.filterTakeaway = true;
					this.ordersStore.filterRooms = true;
					this.ordersStore.refreshOrders();
					this.$router.push("/ops/orders");

					this.ordersStore.ctaIsDueForOrderId = orderCreatedId;
					this.ordersStore.ctaIsPaymentPartial = partialType;
					setTimeout(() => {
						this.ordersStore.ctaIsDueForOrderId = null;
						this.ordersStore.ctaIsPaymentPartial = null;
					}, 2200);
				}
			}

		},
		selectDirectSale() {
			if(this.counterStore.editOrder) {
				this.counterStore.tablesActive = true;
			} else {
				this.counterStore.selectedMode = "counter";
				this.counterStore.selectedTable = null;
				this.counterStore.coverNum = 0;
				this.counterStore.coverCharge = 0;
				this.counterStore.deliveryCosts = 0;
				this.counterStore.takeawayCosts = 0;
			}
		},
		selectQr() {
			this.counterStore.tablesActive = true;
		},
		selectDelivery() {
			if(!this.counterStore.editOrder) {
				this.notInPlaceType = 'delivery';
				this.notInPlaceActive = true
			}
		},
		selectTakeaway() {
			if(!this.counterStore.editOrder) {
				this.notInPlaceType = 'takeaway';
				this.notInPlaceActive = true;
			}
		},
		resetSwipe() {
			this.translateX = 0;
			this.endingAnimation = false;
		},
		selectedTable() {
			if(this.postTableSelectAction) {
				this.postTableSelectAction();
				this.postTableSelectAction = null;
			}
		},
		getSessionGetParams() {
			let rawParams = sessionStorage.getItem('get_params');
			let params = null;
			try {
				params = rawParams ? JSON.parse(rawParams) : null;
			} catch(e) {
				params = null;
			}
			return params;
		},
		getCustomerFromToken() {
			this.customersStore.getCustomerFromToken(this.paramsCustomerToken, (success, customer, customerType) => {
				if(success) {
					this.counterStore.selectedCustomer = {...customer, type: customerType};
					this.notificationStore.showNotification('success-customer-linked', [customer?.name || this.getString('customer')]);
					let params = this.getSessionGetParams();
					if(params && params?.business_id) {
						delete params.business_id;
						sessionStorage.setItem('get_params', JSON.stringify(params));
					}
				} else {
					this.notificationStore.showNotification('warning-customer-missing');
				}
			});
		}
	},
	mounted() {
		let params = this.getSessionGetParams();
		if(params && params?.customer_token) {
			this.paramsCustomerToken = params.customer_token;
			delete params.customer_token;
			sessionStorage.setItem('get_params', JSON.stringify(params));
		}
		if(this.userStore.currBusinessId && this.paramsCustomerToken) {
			this.getCustomerFromToken();
		}
	},
	beforeUnmount() {
		this.resetSwipe();
	},
	watch: {
		"userStore.currBusinessId"(val, oldVal) {
			if(!!val && !oldVal && this.paramsCustomerToken) {
				this.getCustomerFromToken();
			} else if(!!val && !!oldVal && val !== oldVal && this.paramsCustomerToken) {
				this.paramsCustomerToken = null;
			}
		},
		"ordersStore.transitioningMobileOrderSummary"(val) {
			if(!val) {
				this.resetSwipe();
			}
		},
		"counterStore.tablesActive"() {
			this.postTableSelectAction = null;
		}
	}
}
</script>

<style lang="scss" scoped>
.icon-dimension-20 {
	width: 20px;
	height: 20px;
}
.counter-order {
	--summary-h-padding: 20px;
	--summary-v-padding: 10px;

	background-color: var(--color-bg);
	box-shadow: 0 0 13px var(--color-box-shadow-1);
	border-radius: 13px;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	transform: translateX(0);
	transition: transform 0.15s ease, height 0.2s linear, padding 0.2s linear, margin-right 0.5s ease;

	&.swipe-delete {
		transition: transform 0.01s ease, height 0.2s linear, padding 0.2s linear, margin-right 0.5s ease;
	}

	@media (max-width: 1080px) {
		--summary-h-padding: 16px;
	}

	@media (max-width: 420px) {
		--summary-h-padding: 12px;
	}

	.counter-header {
		padding: var(--summary-v-padding) var(--summary-h-padding);
		border-bottom: 1px solid var(--color-border-2);

		.row-header {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.order-existence {
				font-size: 14px;
				font-weight: 500;
				color: var(--color-primary);
				@include truncateString();
				max-width: 50%;
			}

			.order-title {
				font-size: 14px;
				max-width: 50%;
				@include truncateString();
			}

			.order-switches {
				display: flex;
				align-items: center;

				.order-switch {
					border-radius: 13px;
					border: 1px solid $primary;
					display: flex;
					justify-content: center;
					align-items: center;
					padding: 9px;
					margin-right: 8px;
					transition: background-color 0.25s ease-in-out;
					cursor: pointer;

					img {
						width: 16px;
						height: 16px;
					}

					&.selected {
						background-color: var(--color-active-button);
					}
				}

				.order-switch-selected {
					border: 1px solid rgba(0,0,0,0);
					background-color: $alpha_2;
				}
			}

			.order-edit {
				.icon-button {
					width: 36px;
					height: 36px;
				}
			}

		}


	}

	.courses-selector-container {
		overflow-x: auto;
		white-space: nowrap;
		@include hideScrollbar();
		box-shadow: inset 0 2px 3px rgba(7, 82, 163, 0.1),inset 0 -2px 3px rgba(7, 82, 163, 0.1);
		flex-shrink: 0;
		display: flex;
		border-top: 1px solid var(--color-border-2);

		.courses-selector {
			display: flex;
			gap: 8px;
			padding: 8px var(--summary-h-padding);

			.course-selector {
				border-radius: 13px;
				border: 1px solid var(--color-primary);
				min-width: 36px;
				height: 36px;
				text-align: center;
				font-size: 16px;
				color: var(--color-primary);
				cursor: pointer;
				transition: background-color 0.25s ease-in-out;
				display: flex;
				justify-content: center;
				align-items: center;
				user-select: none;
				&.selected {
					background-color: var(--color-active-button);
					color: var(--color-active-button-text);
				}
				&.done {
					border-color: var(--color-alpha-4);
					color: var(--color-alpha-4);
				}
				&.current {
					background-color: var(--color-primary);
					color: var(--color-bg);

					&.selected {
						background-color: var(--color-secondary);
						color: var(--color-primary);
					}
				}
			}
			.course-add {
				border-radius: 13px;
				border: 1px solid var(--color-primary);
				min-width: 36px;
				height: 36px;
				font-size: 22px;
				color: var(--color-primary);
				cursor: pointer;
				transition: background-color 0.25s ease-in-out;
				display: flex;
				justify-content: center;
				align-items: center;
				user-select: none;
				background-color: var(--color-alpha-1);
				&:hover {
					background-color: var(--color-alpha-2);
				}
			}
		}
	}

	.counter-body {
		flex-grow: 1;
		overflow-y: auto;
		@include hideScrollbar();

		.items-container {

			.items-summary-container {
				background: rgb(252,34,145);
				background: linear-gradient(270deg, rgba(252,34,145,1) 0%, rgba(116,8,63,1) 100%);


				.order-summary-item {
					padding: 10px var(--summary-h-padding);
					border-bottom: 1px solid var(--color-border-2);
				}

				.order-summary-item:last-child {
					border-bottom: 0;
				}

				.button-costs-container	{
					background-color: var(--color-bg);
					padding: 5px 7px;

					.button-costs {
						margin: 12px var(--summary-h-padding);
						width: calc(100% - 2 * var(--summary-h-padding));
						max-width: unset;
					}

				}

			}

			.notes-container {
				border-top: 1px solid var(--color-border-2);
				padding: 8px var(--summary-h-padding);

				.notes-title {
					font-size: 16px;
					color: var(--color-txt);
					font-weight: 700;
					margin-bottom: 4px;
				}

				.notes-body {
					font-size: 14px;
					color: var(--color-txt);
					white-space: pre-wrap;
					word-wrap: break-word;
				}
			}

		}

	}

	.counter-bottom {
		display: flex;
		flex-direction: column;

		.total {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: var(--summary-v-padding) var(--summary-h-padding);
			border-top: 1px solid var(--color-border-2);

			.total-title {
				font-size: 14px;
				color: #B2B2B2;
			}

			.total-value {
				font-size: 14px;
				color: var(--color-txt);
				font-weight: 700;

				.total-value-discount {
					font-size: 12px;
					color: #B2B2B2;
					text-decoration: line-through;
					margin-right: 4px;
					line-height: 15px;
				}
			}
		}

		.custom-button {
			width: 100%;
			max-width: unset;
		}

		.bottom-half {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.custom-button {
				flex-grow: 1;
				border-top: 1px solid var(--color-primary);

				&:last-child {
					border-left: 1px solid var(--color-primary);
				}

				&:first-child {
					border-left: none;
				}

			}

			.secondary-action {
				height: 44px;
			}
		}

		.primary-action-container {
			display: flex;
			justify-content: space-between;
			align-items: center;
			border-bottom-left-radius: 13px;
			border-bottom-right-radius: 13px;
			overflow: hidden;

			.primary-action {
				height: 50px;

				.button-text {
					font-weight: 500;
					color: var(--color-txt-white);
				}
			}

			.mini-action {
				width: 25%;
				height: 50px;
				flex-shrink: 0;
				border-top: 1px solid var(--color-primary);

				:deep(.button-icon) {
					padding: 0;
					width: 18px;
					height: 15px;
					img {
						object-fit: contain;
						width: 100%;
						height: 100%;
						max-width: unset;
						max-height: unset;
					}
				}
			}
			.button-with-icon {
				width: 20%;
				min-width: 80px;
			}
		}
	}

	.custom-button {
		position: relative;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: var(--color-primary);
		color: var(--color-secondary);

		&.outline {
			background-color: transparent;
			color: var(--color-primary);
		}
		
		&.disabled {
			cursor: not-allowed;
			pointer-events: none;
			opacity: 0.5;
		}
		
		&.loading {
			.button-text, .button-icon {
				visibility: hidden;
			}
		}

		.button-icon {
			width: 18px;
			height: 15px;
			object-fit: contain;
		}
		
		.app-loader {
			position: absolute;
		}

	}

	@media (max-height: 450px) {
		min-height: 100%;
		height: auto;

		.counter-body {
			min-height: 155px;
			height: auto;
			overflow-y: unset;
		}
	}
}
</style>